import css from "styled-jsx/css";
import { ALWAYS_ON_TOP } from "constants/z-index";
import colors from "/styles/colors";
import {
  BACKGROUND_GRAY_COLOR_NAME,
  WHITE_COLOR_NAME,
  DEV_DARKER_TINT_02,
  CRM_DARKER_TINT_02
} from "styles/color-consts";

export const componentStyles = css.global`
  .modal-screen {
    .product-close {
      display: flex;
      justify-content: flex-end;
      z-index: ${ALWAYS_ON_TOP};
      .close-wrapper {
        display: flex;
        cursor: pointer;
        .close-text {
          color: ${colors[WHITE_COLOR_NAME]};
          padding-right: 12px;
          font-size: 1.25rem;
        }
      }
    }
    .modal-screen-content {
      margin-top: 22px;
      height: 600px;
      width: 1000px;
      background-color: white;
      position: relative;
      display: flex;
      flex-direction: row;
      border-radius: 12px;
      background-color: ${colors[BACKGROUND_GRAY_COLOR_NAME]};
      outline: 12px solid rgba(255, 255, 255, 0.3);

      .close-icon {
        width: 28px;
        height: 22px;
      }

      .left-section {
        width: 50%;
        height: 100%;
        padding: 50px 0 0 50px;

        .logo-image {
          .picture-component {
            img {
              height: 50px;
            }
          }
        }

        .title-wrapper {
          padding-top: 12px;
          .core-title {
            font-size: 1.5rem;
            font-weight: 600;
            line-height: 32px;
          }
        }

        .subtitle-wrapper {
          padding-top: 12px;
          .monday-markup-language-component {
            font-size: 1rem;
            line-height: 24px;
          }
        }

        .departments-title {
          font-size: 0.875rem;
          padding: 32px 0 10px 0;
        }
        .card-departments {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          .department {
            font-size: 0.875rem;
          }
        }

        .card-use-cases-wrapper {
          padding-top: 20px;
          .title-wrapper {
            .core-title {
              font-size: 1rem;
              font-weight: 600;
            }
          }
          .card-use-cases {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            flex-wrap: wrap;
            gap: 8px;
            padding-top: 10px;
            .tag .tag-text {
              font-size: 0.875rem;
            }
          }
        }
        .button-wrapper {
          display: flex;
          justify-content: left;
          padding-top: 40px;
          .signup-button .signup-button-wrapper {
            align-items: flex-start;
          }
          &.crm {
            .signup-form-core-component-wrapper .signup-button-wrapper.button-with-arrow .signup-button {
              background-color: ${colors[CRM_DARKER_TINT_02]};
            }
          }
          &.dev {
            .signup-form-core-component-wrapper .signup-button-wrapper.button-with-arrow .signup-button {
              background-color: ${colors[DEV_DARKER_TINT_02]};
            }
          }
        }
      }

      .right-section {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        .picture-component {
          img {
            width: 100%;
          }
        }
      }
    }
  }
`;
